import { getObjectValue } from '@services/object-extensions';
import { JsonResponseParser } from './json-response.parser';

export class IndustrySectorsParser extends JsonResponseParser {
  /**
   * Parses the response into a JSON.
   * @param {*} response
   */
  parse(response) {
    const industrySectors = super.parse(response);
    const mainSectionDescriptions = {
      title: getObjectValue(industrySectors, 'title', 'Settori di Mercato'),
      subtitle: getObjectValue(
        industrySectors,
        'subtitle',
        'Un nuovo modo di condurre il tuo business, con le tecnologie emergenti.'
      ),
      paragraph: getObjectValue(industrySectors, 'body', '')
    };

    const defaultMainSectionDarkTheme = true;
    const defaultMainSectionImageUrl = '/images/servizi-soluzioni.jpg';

    const mainSectionDarkTheme = getObjectValue(
      industrySectors,
      'dark',
      defaultMainSectionDarkTheme
    );
    const mainSectionImageUrl = getObjectValue(
      industrySectors,
      'imgUrl',
      defaultMainSectionImageUrl
    );

    const navbarItems = industrySectors?.map((element) => ({
      title: getObjectValue(element, 'title', ''),
      target: getObjectValue(element, '_id', '')
    }));

    const pages = industrySectors?.map((element) => ({
      id: getObjectValue(element, '_id', ''),
      categoryId: getObjectValue(element, 'title', '').replace(/\s+/g, ''),
      title: getObjectValue(element, 'title', ''),
      subtitle: getObjectValue(element, 'subtitle', ''),
      darkTheme: getObjectValue(element, 'dark', false),
      backgroundImage: getObjectValue(element, 'imgUrl', ''),
      body: { __html: getObjectValue(element, 'body', '') },
      additionalInfo: getObjectValue(element, 'additionalInfo', [])?.map((el) => ({
        title: getObjectValue(el, 'title', ''),
        body: getObjectValue(el, 'body', '')
      }))
    }));
    return {
      mainSectionDescriptions,
      mainSectionImageUrl,
      mainSectionDarkTheme,
      navbarItems,
      pages
    };
  }
}
